import React, { useState, useCallback } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Timer from "./Timer";
import TaskPanel from "./components/TaskPanel";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import { showErrorNotification } from "./utils/helpers";
import { sessionManager } from "./utils/sessionManager";

const App = () => {
  const [sessionRefreshTrigger, setSessionRefreshTrigger] = useState(0);
  const [isTaskPanelExpanded, setIsTaskPanelExpanded] = useState(false);

  const handleAddTimerSession = useCallback(async (sessionData) => {
    try {
      console.log("App: Creating timer session with data:", sessionData);
      // Use sessionManager instead of direct db call
      const session = await sessionManager.createSession(null, {
        ...sessionData,
        type: "timer",
        description: `Timer session: ${Math.floor(
          sessionData.duration / 60
        )}m ${sessionData.duration % 60}s`,
        createdAt: sessionData.startTime,
      });
      console.log("App: Timer session created:", session);
      // Trigger refresh of TimerActivityLog
      setSessionRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      console.error("Failed to save timer session:", error);
      showErrorNotification("Failed to save timer session. Please try again.");
    }
  }, []);

  const handleMarkTaskCompleted = useCallback(async (taskId) => {
    try {
      const db = (await import("./utils/db")).default;
      const task = await db.get("tasks", taskId);
      if (task) {
        await db.updateTask({ ...task, status: "completed" });
        // Trigger refresh of TimerActivityLog
        setSessionRefreshTrigger((prev) => prev + 1);
      }
    } catch (error) {
      console.error("Failed to mark task as completed:", error);
      showErrorNotification("Failed to update task status. Please try again.");
    }
  }, []);

  return (
    <div className="app-layout">
      <div className="timer-section">
        <ErrorBoundary>
          <Timer
            onAddTimerSession={handleAddTimerSession}
            onMarkTaskCompleted={handleMarkTaskCompleted}
          />
        </ErrorBoundary>
      </div>

      {/* Mobile Task Management Toggle */}
      <div className="mobile-task-toggle">
        <button
          className="task-toggle-btn"
          onClick={() => setIsTaskPanelExpanded(!isTaskPanelExpanded)}
        >
          <span className="toggle-icon">
            {isTaskPanelExpanded ? "Hide" : "Show"}
          </span>
          Task Management
        </button>
      </div>

      <div
        className={`task-section ${
          isTaskPanelExpanded ? "expanded" : "collapsed"
        }`}
      >
        <ErrorBoundary>
          <TaskPanel sessionRefreshTrigger={sessionRefreshTrigger} />
        </ErrorBoundary>
      </div>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
